import {SHORTSWORKS_CHANNEL_TALK} from "@app/pages/auth/FindPassword"
import {
  Badge,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Sheet,
  SheetContent,
  SheetTrigger,
  SidebarTrigger,
  useModal,
} from "@shortsworks/ui";
import {
  CircleUser,
  LineChart,
  Menu,
  Package,
  Package2,
  ShoppingCart,
  Users,
} from "lucide-react";

import { Link, useNavigate } from "react-router-dom";
import { cn } from "@shortsworks/ui/lib/utils";
import { LogoutModal } from "@app/components/modals/AuthModal";
import {clearAuthToken, useGetAccount, useGetAccountPlatform} from "@shortsworks/user-api"
import { DEVICE, USER_DEVICE_TYPE } from "@app/types/device";
import { flutterCommunicationCode, sendToFlutter } from "@app/types/flutter";
import { Path } from "@app/route_path";

interface HeaderProps {
  className?: string;
}

export const Header = ({ className }: HeaderProps) => {
  const { showModal } = useModal();
  const navigate = useNavigate();

  const {data: accountPlatform, isSuccess: isSuccessGetAccountPlatform} = useGetAccountPlatform();

  const handleLogout = async () => {
    const logoutModalResult = await showModal(LogoutModal).promise();

    if (logoutModalResult.value) {
      clearAuthToken();
      const userDeviceType = sessionStorage.getItem(USER_DEVICE_TYPE);
      if (userDeviceType === DEVICE.MOBILE) {
        return sendToFlutter(flutterCommunicationCode.LOGOUT);
      }
      return navigate(Path.LOGIN);
    }
  };

  const handleRouteAccountSetting = () => {
    return navigate(Path.ACCOUNT_SETTINGS);
  }

  const handleRouteChannelTalk = () => {
    return location.assign(SHORTSWORKS_CHANNEL_TALK);
  }

  return (
    <header
      className={cn(
        "flex h-14 items-center gap-4 border-b px-4 lg:h-[60px] lg:px-6",
        className,
      )}
    >
      <div className="w-full flex-1">
        <SidebarTrigger />
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="icon" className="rounded-full">
            <CircleUser className="h-5 w-5" />
            <span className="sr-only">Toggle user menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {
            isSuccessGetAccountPlatform &&
              <>
                <DropdownMenuLabel>{accountPlatform.data.name}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={handleRouteAccountSetting}>회원정보</DropdownMenuItem>
                <DropdownMenuItem onClick={handleRouteChannelTalk}>문의하기</DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={handleLogout}>로그아웃</DropdownMenuItem>
              </>
          }
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
};
